import React from 'react'

import { ModalCloseIcon, ButtonClose } from 'Stories/Icon/Icon.stories'

import { CustomModalProps } from './CustomModalProps'

import {
  ContentContainer,
  ModalCloseButton,
  ModalHeader,
  ModalTitle,
  ModalWrapper,
} from './styles'

const CustomModal: React.FC<CustomModalProps> = ({
  content,
  children,
  promocode,
  handleClose,
}) => (
  <ModalWrapper>
    <ModalHeader
      // @ts-ignore
      promocode={promocode}
    >
      <ModalTitle>{content}</ModalTitle>
      <ModalCloseButton onClick={handleClose}>
        {promocode ? <ButtonClose /> : <ModalCloseIcon />}
      </ModalCloseButton>
    </ModalHeader>

    <ContentContainer>{children}</ContentContainer>
  </ModalWrapper>
)

export default CustomModal
